import { render, staticRenderFns } from "./ForumTagsView.vue?vue&type=template&id=32258048&"
import script from "./ForumTagsView.vue?vue&type=script&lang=js&"
export * from "./ForumTagsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports